import { render, staticRenderFns } from "./calendar_team.vue?vue&type=template&id=1604bf5c"
import script from "./calendar_team.vue?vue&type=script&lang=js"
export * from "./calendar_team.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports